// extracted by mini-css-extract-plugin
export default {"root":"_1NnaIV5K","reverse":"_2gedrkVo","message":"GLSDldgr","default":"TjTwRPGM","secondary":"tXeAKBgl","warning":"_1ieqTdx3","timestamp":"_3YpTfike"};